import * as Types from '../../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type UpdateEmployeePayrollStatusMutationVariables = Types.Exact<{
  employeeId: Types.Scalars['Int']
  payrollStatus: Types.PayrollStatusInput
}>

export type UpdateEmployeePayrollStatusMutation = {
  __typename?: 'Mutation'
  updateEmployee?: {
    __typename?: 'UpdateEmployeePayload'
    employee?: {
      __typename?: 'Employee'
      id: number
      terminationDate?: string | null
      enrollmentInfo: {
        __typename?: 'EmployeeEnrollment'
        accountStatus: Types.EmployeeAccountStatus
        payrollSystemStatus?: Types.EmployeePayrollSystemStatusEnum | null
      }
      rosterEntryOverride?: {
        __typename?: 'RosterEntryOverride'
        terminationDate?: string | null
        payrollSystemStatus?: Types.EmployeePayrollSystemStatusEnum | null
      } | null
    } | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const UpdateEmployeePayrollStatusDocument = `
    mutation UpdateEmployeePayrollStatus($employeeId: Int!, $payrollStatus: PayrollStatusInput!) {
  updateEmployee(input: {employeeId: $employeeId, payrollStatus: $payrollStatus}) {
    employee {
      id
      terminationDate
      enrollmentInfo {
        accountStatus
        payrollSystemStatus
      }
      rosterEntryOverride {
        terminationDate
        payrollSystemStatus
      }
    }
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useUpdateEmployeePayrollStatusMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateEmployeePayrollStatusMutation,
    TError,
    UpdateEmployeePayrollStatusMutationVariables,
    TContext
  >
) =>
  useMutation<
    UpdateEmployeePayrollStatusMutation,
    TError,
    UpdateEmployeePayrollStatusMutationVariables,
    TContext
  >(
    ['UpdateEmployeePayrollStatus'],
    (variables?: UpdateEmployeePayrollStatusMutationVariables) =>
      fetchGql<UpdateEmployeePayrollStatusMutation, UpdateEmployeePayrollStatusMutationVariables>(
        UpdateEmployeePayrollStatusDocument,
        variables
      )(),
    options
  )
